/**
 * The target passage with per-character highlighting for what's been typed.
 *
 * Only the typed prefix gets per-character spans (correct vs incorrect); the
 * caret is one span and the untyped remainder is a single text node. This keeps
 * the DOM tiny even for long (5-minute) passages, which matters for render perf.
 */
export function TextDisplay({ text, typed }: { text: string; typed: string }) {
  const n = Math.min(typed.length, text.length);
  const done = text.slice(0, n).split("");
  return (
    <p
      aria-hidden
      className="select-none font-mono text-lg leading-loose tracking-wide sm:text-xl"
    >
      {done.map((ch, i) => (
        <span
          key={`${i}-${ch}`}
          className={
            typed[i] === ch
              ? "text-foreground"
              : "rounded-sm bg-destructive/20 text-destructive"
          }
        >
          {ch}
        </span>
      ))}
      {n < text.length && (
        <span className="rounded-sm bg-primary/30 text-foreground">
          {text[n]}
        </span>
      )}
      <span className="text-muted-foreground">{text.slice(n + 1)}</span>
    </p>
  );
}
